// extracted by mini-css-extract-plugin
export default {"airplaneSizingContainer":"Vaa-z","narrowOptionButtons":"Waa-z","noOptions":"Xaa-z"};